import create from "zustand";

export const useActionsStore = create((set) => ({
  zoom: 100,
  setZoom: (newZoomValue) => set((state) => ({ zoom: newZoomValue })),

  isAddingPeople: false,
  setIsAddingPeople: (isAdding) => set((state) => ({ isAddingPeople: isAdding })),
}));
